import { createPivotTransformer } from './create-pivot-transformer';
import { MIN_PER_HOUR, SEC_PER_MIN } from '../shared/constants';
import { createResolvePivotKey } from '../shared/resolve-pivot-key';
import { NormalizedUnitValue } from '../shared/types';
import { fpMultiply, toNumber } from '../shared/utils';

/** Pivot = seconds. */
export const TIME_PIVOT: Record<string, number> = {
  hr: SEC_PER_MIN * MIN_PER_HOUR,
  min: SEC_PER_MIN,
  sec: 1,
  ms: 0.001,
};

const resolveTimePivotKey = createResolvePivotKey(TIME_PIVOT);
const pivotTransform = createPivotTransformer(TIME_PIVOT, resolveTimePivotKey);

/**
 * Converts between hrs/min/sec via a seconds pivot. Duration/timer targets
 * normalize to raw seconds; H:MM formatting happens in formatDuration.
 */
export const transformTime = (
  unitValue: NormalizedUnitValue,
  newUnits?: string
): NormalizedUnitValue => {
  const targetKey = newUnits?.toLowerCase();

  if (targetKey === 'duration' || targetKey === 'timer') {
    const value = toNumber(unitValue.value);
    const sourcePivotKey = resolveTimePivotKey(unitValue.units);
    const sourceFactor = sourcePivotKey ? TIME_PIVOT[sourcePivotKey] : undefined;
    if (value == null || sourceFactor == null) return unitValue;

    return { value: fpMultiply(value, sourceFactor), units: 'sec' };
  }

  return pivotTransform(unitValue, newUnits);
};
